import { Fragment, type ReactElement, type ReactNode } from 'react'
import { type PermissionDefinitionGroup } from '@front/model'
import { Stack } from '@mantine/core'
import { type PermissionDefinition, type PermissionType } from '@terros/common'

type Props = {
  definitions: PermissionDefinitionGroup | undefined
  render: (type: PermissionType, definition: PermissionDefinition) => ReactNode
}

export const PermissionDefinitionList = ({ definitions, render }: Props): ReactElement => (
  <Stack gap='lg'>
    {Array.from(definitions?.entries() ?? []).map(([type, definition]) => (
      <Fragment key={type}>{render(type, definition)}</Fragment>
    ))}
  </Stack>
)
